import ConfigFile from "../../../../datasets/config_file";

export const calculatePenaltyAmount = (savingsType, savingsClass, savingInfoObj) => {
    let transferFee = 0;
    if (+savingInfoObj.newTransferAmt > 0 || +savingInfoObj.newTransferFee > 0){
        if (savingsType === "CD"){
            const transferAmt = +savingInfoObj.newTransferAmt;
            const intRate = +savingInfoObj.intRate/100;
            transferFee = ((+intRate / 12) * transferAmt * 3).toFixed(2);  
        }
        if (savingsClass === "retirement"){
            const feePercent = ConfigFile.savings.savings401KOverdraftFee;
            transferFee = (+savingInfoObj.newTransferAmt * +feePercent/100).toFixed(2);
        }    
        savingInfoObj.newTransferFee = transferFee;   
    }
    return transferFee;
}

export default calculatePenaltyAmount;